import React from "react"

const ResponsiveImage = ({ src, alt = "", className = "", onClick = null, width = '100%' }) => {
  const srcset = src

  // Si srcset es un string → tratamos como "src" normal
  if (typeof srcset === "string") {
    return (
      <img
        src={src}
        alt={alt}
        width={width}
        className={className}
        loading="lazy"
        decoding="async"
        onClick={() => {
          typeof onClick === "function" ? onClick() : null
        }}
      />
    )
  }

  // Si NO es un objeto válido → no renderizar
  if (!srcset || typeof srcset !== "object") {
    return ''
  }

  if (Object.keys(srcset) == 0) {
    return ''
  }

  // Convertir API hash { "150w": "...", "300w": "...", ... }
  const srcsetString = Object.entries(srcset)
    .filter(([key]) => key.endsWith("w"))
    .map(([key, url]) => `${url} ${key}`)
    .join(", ");

  return (
    <img
      src={srcset["300w"] || srcset["original"]} // default
      srcSet={srcsetString}
      sizes="
        (max-width: 500px) 100vw,
        (max-width: 900px) 50vw,
        33vw
      "
      alt={alt}
      className={className}
      width={width}
      loading="lazy"
      decoding="async"
      onClick={() => {
        typeof onClick === "function" ? onClick() : null
      }}
    />
  );
}

export default ResponsiveImage
